// Minimal set-symbol pill. We don't ship the Keyrune icon font (adds
// ~300KB and is visually loud), so we render the 3-4 char set code in a
// small bordered chip that lines up next to mana pips and price. Matches
// the existing deck-row typography (monospace, tabular-nums, subtle).
//
// The set code is upper-cased for readability (`otj` → `OTJ`).

import { cn } from "../lib/cn";

interface Props {
  code: string | null | undefined;
  className?: string;
}

export default function SetSymbol({ code, className }: Props) {
  if (!code) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded-sm border border-border bg-bg-raised/40 px-1 py-[1px] font-mono text-[9px] uppercase tracking-wider text-fg-subtle leading-none",
        className,
      )}
      title={`Set: ${code.toUpperCase()}`}
    >
      {code.toUpperCase()}
    </span>
  );
}
